export default "__VITE_ASSET__CM4uU5tR__"